<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">

   <div class="app-main row">
      <div id="main" class="col s12" >
         <router-view name="main"></router-view>
      </div><!-- end main -->
   </div><!-- end container -->

<div class="yo-text-xs yo-align-right">versione 21.01</div>
</div> <!-- end app -->
</template>

<script>
export default {
   name: 'app',
   components: {
   }
}
</script>
